import { Fragment, useMemo } from "react";
import Episode from "./Episode";
import Title from './Title';
import { BranchFunction } from "../../../Functions";

export type Entry<T> = {
    [K in keyof T]: [K, T[K]];
}[keyof T][];

type pages = (
    'title'     |
    'episode'   |
    'somethingwrong'
);

const TeamAdmin = ({ path, query, hash, isClient }:{ path: string, query: string, hash: string, isClient: boolean }) => {
    const body = useMemo(()=>{
        const [, serviceId, titleId, episodeId, snapshotId] = new RegExp('^/([^/]+)/([^/]+)/?([^/]+)?/?([^/]+)?').exec(path) || [];
    
        const currentBranch = BranchFunction<pages, {serviceId: string, titleId?: string, episodeId?: string}>(
            ({serviceId, titleId, episodeId}),[
                {
                    validator: ({serviceId, titleId, episodeId}) => !!serviceId && !!titleId && !!episodeId,
                    defaultValue: 'episode',
                },
                {
                    validator: ({serviceId, titleId, episodeId}) => !!serviceId && !!titleId,
                    defaultValue: 'title',
                }
            ],
            'title'
        );
    
        if(currentBranch === 'episode'){
            return <Episode
                serviceId={serviceId ?? ""} titleId={titleId ?? ""} episodeId={episodeId ?? ""} snapshotId={snapshotId ?? ""}
                query={query} hash={hash} isClient={isClient}
            />;
        } else if (currentBranch === 'title'){
            return <Title serviceId={serviceId ?? ""} titleId={titleId ?? ""} />;
        } else {
            return <div>Something wrong</div>;
        }
        
    },[hash, isClient, path, query]);
    
    return (<Fragment>
        {body}
    </Fragment>);
}

export default TeamAdmin;